import { ICarePlan } from './icare-plan';
export interface ICarePlanIntent {
    codeIntentIdentifier: string;
    Display: string;
    definition: string;
    tenantId: number;
    language: string;
    carePlan: ICarePlan[];
}